// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__dialogButtons___KFZhX {
  display: flex;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 72px;
  flex-direction: row;
}

.styles__cancel___HzVH8 {
  width: 50%;
  font-size: 16px;
  font-weight: 500;
  align-self: flex-end;
  height: 72px;
  padding: 0;
  border: none;
  border-radius: 0 0 0 3px;
  transition: all 0.25s;
}

.styles__cancel___HzVH8:hover {
    background: #e1dfe1;
  }

.styles__confirm___NXw3U {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  border-left: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  border-radius: 0 0 3px;
}

.styles__confirm___NXw3U.styles__confirm___NXw3U:not(:disabled):hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    color: white;
  }

.styles__confirm___NXw3U:disabled {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
    background: none !important;
  }

.styles__dialogContainer___Zy6Ul {
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
  bottom: 0;
  transition: all 200ms;
  z-index: 10000;
}

.styles__overlay___WHH0B {
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}

.styles__dialog___zu2V3 {
  display: flex;
  align-items: center;
  position: relative;
  background: white;
  border-radius: 3px;
  width: 550px;
  flex-flow: column nowrap;
  height: auto;
  margin: 0 auto;
  max-height: 46rem;
  z-index: 2;
}

.styles__section___s2Qfe {
  display: flex;
  flex-direction: column;
  margin: 0;
  align-items: center;
  justify-content: center;
  border-radius: 3px 3px 0 0;
  min-height: 140px;
  padding: 20px;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
}

.styles__header___oUHeT {
  font-weight: 500;
  font-size: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  margin-bottom: 2rem;
  padding-top: 20px;
}

.styles__bodyText___VlPoo {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Dialog/styles.css"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,OAAO;EACP,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;AAKvB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EAEE,mDAAa;EACb,mEAAkC;EAClC,sBAAsB;AAUxB;;AARE;IACE,wDAAkB;IAClB,YAAY;EACd;;AACA;IACE,mDAAe;IACf,2BAA2B;EAC7B;;AAGF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,MAAM;EACN,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,qEAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mDAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":["@value colors: \"styles/colors.css\";\n@value borderColor, gtBlue, textDark from colors;\n@value helpers: \"styles/helpers.css\";\n\n.dialogButtons {\n  display: flex;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  height: 72px;\n  flex-direction: row;\n}\n\n.cancel {\n  width: 50%;\n  font-size: 16px;\n  font-weight: 500;\n  align-self: flex-end;\n  height: 72px;\n  padding: 0;\n  border: none;\n  border-radius: 0 0 0 3px;\n  transition: all 0.25s;\n\n  &:hover {\n    background: #e1dfe1;\n  }\n}\n\n.confirm {\n  composes: cancel;\n  color: gtBlue;\n  border-left: 1px solid borderColor;\n  border-radius: 0 0 3px;\n\n  &:not(:disabled)&:hover {\n    background: gtBlue;\n    color: white;\n  }\n  &:disabled {\n    color: textDark;\n    background: none !important;\n  }\n}\n\n.dialogContainer {\n  display: flex;\n  position: fixed;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column nowrap;\n  height: 100vh;\n  width: 100vw;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  transition: all 200ms;\n  z-index: 10000;\n}\n\n.overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n\n.dialog {\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: white;\n  border-radius: 3px;\n  width: 550px;\n  flex-flow: column nowrap;\n  height: auto;\n  margin: 0 auto;\n  max-height: 46rem;\n  z-index: 2;\n}\n\n.section {\n  composes: section from helpers;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px 3px 0 0;\n  min-height: 140px;\n  padding: 20px;\n  border-bottom: 1px solid borderColor;\n}\n\n.header {\n  font-weight: 500;\n  font-size: 16px;\n  color: textDark;\n  margin-bottom: 2rem;\n  padding-top: 20px;\n}\n\n.bodyText {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"helpers": `"styles/helpers.css"`,
	"dialogButtons": `styles__dialogButtons___KFZhX`,
	"cancel": `styles__cancel___HzVH8`,
	"confirm": `styles__confirm___NXw3U styles__cancel___HzVH8`,
	"dialogContainer": `styles__dialogContainer___Zy6Ul`,
	"overlay": `styles__overlay___WHH0B`,
	"dialog": `styles__dialog___zu2V3`,
	"section": `styles__section___s2Qfe ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"header": `styles__header___oUHeT`,
	"bodyText": `styles__bodyText___VlPoo`
};
export default ___CSS_LOADER_EXPORT___;
